<template>
    <div style="background-color:white">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        class="form-control border-0 "
                        :options="optionTransaction"
                        v-model="search.transaction_type"
                        label="name"
                        select-label=""
                        deselectLabel=""
                        placeholder="ช่องทางการจ่ายเงิน"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        class="form-control border-0"
                        :options="optionDepartment"
                        v-model="search.department"
                        label="department_name"
                        select-label=""
                        multiple
                        :closeOnSelect="false"
                        style="height: 100%"
                        deselectLabel=""
                        placeholder="แผนก"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        class="form-control border-0"
                        :options="optionEmployee"
                        v-model="search.employee"
                        :customLabel="employeeLabel"
                        multiple
                        style="height: 100%"
                        :closeOnSelect="false"
                        select-label=""
                        deselectLabel=""
                        placeholder="พนักงาน"
                        track-by="id">
                    </multiselect>
                    <b-form-select
                        :options="optionActive"
                        v-model="search.active">
                    </b-form-select>
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchSalaryPayment"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp;&nbsp;
                    <template v-if="paid_period === 1">
                        <button class="btn btn-primary my-2 my-sm-0"
                                @click="showPreviewSalaryMonthModal"
                                type="button">
                            <icon name="file-alt"></icon>
                            ตัวอย่างเงินเดือน PDF
                        </button>&nbsp;&nbsp;
                        <button class="btn btn-warning my-2 my-sm-0"
                                @click="showGenerateSlipMonthModal"
                                type="button">
                            <icon name="plus"></icon>
                            สร้าง slip เงินเดือน
                        </button>
                    </template>
                    <template v-else>
                        <button class="btn btn-primary my-2 my-sm-0"
                                @click="showPreviewSalaryModal"
                                type="button">
                            <icon name="file-alt"></icon>
                            ตัวอย่างเงินเดือน PDF
                        </button>&nbsp;&nbsp;
                        <button class="btn btn-warning my-2 my-sm-0"
                                @click="showGenerateModal"
                                type="button">
                            <icon name="plus"></icon>
                            สร้าง slip เงินเดือน
                        </button>
                    </template>
                    &nbsp;&nbsp;
                    <button class="btn btn-primary my-2 my-sm-0"
                            @click="showReportSalaryModal"
                            type="button">
                        <icon name="print"></icon>
                        รายงานเงินเดือนภาพรวม
                    </button>

                    <button class="btn btn-primary my-2 my-sm-0 ml-2"
                            @click="showFilterSalaryModal"
                            type="button">
                        <icon name="print"></icon>
                        รายงาน slip เงินเดือน
                    </button>

                    <button class="btn btn-primary my-2 my-sm-0 ml-2"
                            @click="showAccept_SalaryModal"
                            type="button">
                        <icon name="print"></icon>
                        ใบเซ็นรับเงิน
                    </button>

                    <button class="btn btn-primary my-2 my-sm-0 ml-2"
                            @click="showPayrollModal"
                            type="button">
                        <icon name="print"></icon>
                        Payroll
                    </button>

                    <button class="btn btn-primary my-2 my-sm-0 ml-2"
                            @click="showCloseModal"
                            type="button">
                        <icon name="print"></icon>
                        ปิดงวดเงินเดือน
                    </button>

                    <button class="btn btn-danger my-2 my-sm-0 ml-2"
                            @click="clearSearch"
                            type="button">
                        <icon name="cog"></icon>
                        ล้างค่าการค้นหา
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <b-navbar toggleable="md" type="light" variant="light">
                <b-navbar-toggle variant="light" target="search_nav_collapse"></b-navbar-toggle>
                <b-collapse variant="light" is-nav id="search_nav_collapse">
                    <b-navbar-nav>
                        <b-nav-item class="item margin"
                                    @click="paid_period = 2 , getEmployeeByPaidPeriod(2)"
                                    :class="{active : status === 2}">
                            &nbsp;&nbsp;ครึ่งเดือน&nbsp;
                        </b-nav-item>
                        <b-nav-item class="item margin"
                                    @click="paid_period = 1 , getEmployeeByPaidPeriod(1)"
                                    :class="{active : status === 1}">
                            &nbsp;&nbsp;เดือน&nbsp;
                        </b-nav-item>
                    </b-navbar-nav>

                </b-collapse>
            </b-navbar>
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">
                        <input type="checkbox"/>
                    </th>
                    <th scope="col">รหัสพนักงาน</th>
                    <th scope="col">ชื่อพนักงาน</th>
                    <th scope="col">ประเภทพนักงาน</th>
                    <th scope="col">แผนก</th>
                    <th scope="col">เงินเดือนสุทธิ</th>
                    <th scope="col">ช่องทางการจ่ายเงิน</th>
                    <th scope="col">วัน/เดือน/ปี ที่จ่าย</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">ดูข้อมูล</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in employeeList">
                    <td>
                        <input type="checkbox"/>
                    </td>
                    <td>{{ data.employee_no }}</td>
                    <td>{{ data.first_name }}</td>
                    <td>
                        <template v-if="data.occupation && data.occupation.type">
                            {{ data.occupation.type.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.occupation && data.occupation.position">
                            {{ data.occupation.position.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.payment_salary && data.payment_salary.length > 0">
                            {{ data.payment_salary[data.payment_salary.length - 1].net_total | currency }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <template v-if="data.transaction && data.transaction.transaction_type">
                            {{ data.transaction.transaction_type.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.date_payment_salary">
                            {{ data.date_payment_salary | moment('DD/MM/YYYY') }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <template v-if="data.work_status.active_status_id == 1">
                            พนักงาน
                        </template>
                        <template v-else>
                            ลาออกแล้ว
                        </template>
                    </td>
                    <td>
                        <button class="btn btn-info"
                                @click="goToPaymentSalary(data.id)">
                            <icon name="eye"></icon>
                            ดูข้อมูล
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="employeeList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getEmployeePage">
            </vue-pagination>
        </div>
        <br>
        <!-- generate slip modal paid period = 2 (week) -->
        <b-modal hide-header hide-footer ref="generate_slip">
            <div style="text-align: center;">
                <h4>เลือกวิกการจ่ายเงินที่ต้องการ generate slip</h4>
                <br/>
                <div class="row form-group" align="center">
                    <div class="col-5 text-right">วิคที่ออกเงินเดือน</div>
                    <div class="col-6">
                        <select class="form-control"
                                v-model="generate.week">
                            <option value="" hidden>เลือกวิกการจ่ายเงิน</option>
                            <option value="1">วิกที่ 1</option>
                            <option value="2">วิกที่ 2</option>
                        </select>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-5 text-right">เดือนที่ต้องการคิดเงินเดือน</div>
                    <div class="col-6">
                        <date-picker
                            :lang="lang"
                            type="month"
                            :format="changeFormat"
                            v-model="generate.date"
                            placeholder="เดือน-ปี"
                            confirm
                            format="MM/YYYY">
                        </date-picker>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-5 text-right">เลือกแผนก</div>
                    <div class="col-6">
                        <multiselect
                            :options="optionDepartment"
                            v-model="generate.department"
                            label="department_name"
                            select-label=""
                            deselectLabel=""
                            placeholder="เลือกแผนก"
                            track-by="id">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-5 text-right">เลือกพนักงาน</div>
                    <div class="col-6">
                        <multiselect
                            :options="optionEmployee"
                            v-model="generate.employee"
                            :customLabel="employeeLabel"
                            multiple
                            :close-on-select="false"
                            select-label=""
                            deselectLabel=""
                            placeholder="เลือกพนักงาน"
                            track-by="id">
                        </multiselect>
                    </div>
                </div>
                <button type="button"
                        @click="generateNewSlip"
                        class="btn btn-success mt-4">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button type="button"
                        @click="hideGenerateModal"
                        class="btn btn-outline-secondary mt-4">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--Payroll-->
        <b-modal hide-header hide-footer ref="payroll_modal">
            <div style="text-align: center;">
                <h4>ออกใบ Payroll</h4>
                <br/>
                <div class="row form-group">
                    <div class="col-4 text-right">วีค</div>
                    <div class="col-6">
                        <b-form-select :options="optionWeek" v-model="payroll.week"></b-form-select>
                    </div>
                </div>
                <!--                <div class="row form-group">-->
                <!--                    <div class="col-4 text-right">เดือน</div>-->
                <!--                    <div class="col-6">-->
                <!--                        <b-form-select :options="optionMonth" v-model="payroll.month"></b-form-select>-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="row form-group">
                    <div class="col-4 text-right">เดือน-ปี</div>
                    <div class="col-6">
                        <date-picker
                            :lang="lang"
                            type="month"
                            :format="changeFormat"
                            v-model="payroll.month"
                            placeholder="เดือน-ปี"
                            confirm
                            format="MM/YYYY">
                        </date-picker>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">เลือกธนาคาร</div>
                    <div class="col-6">
                        <b-form-select
                            v-model="payroll.bank"
                            :options="bankOption">
                        </b-form-select>
                    </div>
                </div>
                <div class="row form-group" v-if="payroll.bank == 1">
                    <div class="col-4 text-right">วันที่ทำรายการ</div>
                    <div class="col-6">
                        <date-picker
                            :lang="lang"
                            type="date"
                            :format="changeFormat"
                            v-model="payroll.trans_date"
                            placeholder="วัน-เดือน-ปี"
                            confirm
                            format="DD/MM/YYYY">
                        </date-picker>
                    </div>
                </div>
                <div class="row form-group" v-if="payroll.bank == 1">
                    <div class="col-4 text-right">วันที่โอนเงิน</div>
                    <div class="col-6">
                        <date-picker
                            :lang="lang"
                            type="date"
                            :format="changeFormat"
                            v-model="payroll.effective_date"
                            placeholder="วัน-เดือน-ปี"
                            confirm
                            format="DD/MM/YYYY">
                        </date-picker>
                    </div>
                </div>
                <div class="row form-group" v-if="payroll.bank == 2">
                    <div class="col-4 text-right">เลขบริษัท</div>
                    <div class="col-6">
                        <input class="form-control" :maxlength="4" v-model="payroll.company_code_t"/>

                    </div>
                </div>
                <div class="row form-group" v-if="payroll.bank == 2">
                    <div class="col-4 text-right">เลขสาขา</div>
                    <div class="col-6">
                        <input class="form-control" :maxlength="3" v-model="payroll.branch_code_t"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12 text-center">
                        <label>เลือกกลุ่มที่ต้องการออกใบ</label>
                    </div>
                    <div style="margin-left: auto;margin-right: auto">
                        <b-form-radio-group v-model="payroll.type" @input="clearValue">
                            <b-form-radio value="1" :checked=true>ทั้งหมด</b-form-radio>
                            <b-form-radio value="2">แผนก</b-form-radio>
                            <b-form-radio value="3">พนักงาน</b-form-radio>
                        </b-form-radio-group>
                    </div>
                </div>
                <div class="row form-group" v-if="payroll.type == 2">
                    <div class="col-4 text-right">เลือกแผนก</div>
                    <div class="col-6">
                        <multiselect
                            :options="optionDepartment"
                            v-model="payroll.department"
                            label="department_name"
                            select-label=""
                            :close-on-select="false"
                            :multiple="true"
                            deselectLabel=""
                            placeholder="เลือกแผนก"
                            track-by="id">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group" v-if="payroll.type == 3">
                    <div class="col-4 text-right">เลือกพนักงาน</div>
                    <div class="col-6">
                        <multiselect
                            :options="optionEmployee"
                            v-model="payroll.employee"
                            :customLabel="employeeLabel"
                            select-label=""
                            deselectLabel=""
                            :close-on-select="false"
                            :multiple="true"
                            placeholder="เลือกพนักงาน"
                            track-by="id">
                        </multiselect>
                    </div>
                </div>
                <button type="button"
                        @click="generatePayroll"
                        class="btn btn-success mt-4">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button type="button"
                        @click="hidePayrollModal"
                        class="btn btn-outline-secondary mt-4">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!-- generate slip modal paid period = 1 (month) -->
        <b-modal hide-header hide-footer ref="generate_slip_month">
            <div style="text-align: center;">
                <h4>generate slip</h4>
                <br/>
                <button type="button"
                        @click="generateNewSlipMonth"
                        class="btn btn-success mt-4">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button type="button"
                        @click="hideGenerateSlipMonthModal"
                        class="btn btn-outline-secondary mt-4">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal size="md" hide-header hide-footer ref="preview_salary">
            <div>
                <preview-salary-modal @submit="previewSalary">
                </preview-salary-modal>
            </div>
        </b-modal>
        <b-modal size="md" hide-header hide-footer ref="preview_salary_month">
            <div>
                <preview-salary-month-modal @submit="previewSalaryMonth">
                </preview-salary-month-modal>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading" no-close-on-backdrop no-close-on-esc>
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal hide-footer hide-header ref="social_security">
            <rate-social-security-modal @submit="saveRateSocialSecurity"></rate-social-security-modal>
        </b-modal>
        <b-modal hide-footer hide-header ref="print_report_salary">
            <report-salary-modal @submit="printReportSalaryPDF"></report-salary-modal>
        </b-modal>
        <b-modal hide-footer hide-header ref="filter_report_salary">
            <filter-salary-modal @submit="FilterSalaryModal"></filter-salary-modal>
        </b-modal>
        <b-modal
            ref="accept_salary"
            hide-header
            hide-footer>
            <div style="text-align: center;">
                <h4>ใบเซ็นรับเงิน</h4>
                <br/>
                <div class="row form-group">
                    <div class="col-4 text-right">วีค</div>
                    <div class="col-6">
                        <b-form-select :options="optionWeek" v-model="optionAccept.week"></b-form-select>
                    </div>
                </div>
                <!--                <div class="row form-group">-->
                <!--                    <div class="col-4 text-right">เดือน</div>-->
                <!--                    <div class="col-6">-->
                <!--                        <b-form-select :options="optionMonth" v-model="optionAccept.month"></b-form-select>-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="row form-group">
                    <div class="col-4 text-right">เดือน-ปี</div>
                    <div class="col-6">
                        <date-picker
                            :lang="lang"
                            type="month"
                            :format="changeFormat"
                            v-model="optionAccept.month"
                            placeholder="เดือน-ปี"
                            confirm
                            format="MM/YYYY">
                        </date-picker>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-4 text-right">ประเภทไฟล์</div>
                    <div class="col-6">
                        <b-form-select :options="optionTypeAccept" v-model="optionAccept.file"></b-form-select>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">ประเภทใบ</div>
                    <div class="col-6">
                        <b-form-select :options="optionGroup" v-model="optionAccept.group"></b-form-select>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12 text-center">
                        <label>เลือกกลุ่มที่ต้องการออกใบ</label>
                    </div>
                    <div style="margin-left: auto;margin-right: auto">
                        <b-form-radio-group v-model="optionAccept.type" @input="clearValue">
                            <b-form-radio value="1" :checked=true>ทั้งหมด</b-form-radio>
                            <b-form-radio value="2">แผนก</b-form-radio>
                            <b-form-radio value="3">พนักงาน</b-form-radio>
                        </b-form-radio-group>
                    </div>
                </div>
                <div class="row form-group" v-if="optionAccept.type == 2">
                    <div class="col-5 text-right">เลือกแผนก</div>
                    <div class="col-6">
                        <multiselect
                            :options="optionDepartment"
                            v-model="optionAccept.department"
                            label="department_name"
                            select-label=""
                            :close-on-select="false"
                            :multiple="true"
                            deselectLabel=""
                            placeholder="เลือกแผนก"
                            track-by="id">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group" v-if="optionAccept.type == 3">
                    <div class="col-5 text-right">เลือกพนักงาน</div>
                    <div class="col-6">
                        <multiselect
                            :options="optionEmployee"
                            v-model="optionAccept.employee"
                            :customLabel="employeeLabel"
                            select-label=""
                            deselectLabel=""
                            :close-on-select="false"
                            :multiple="true"
                            placeholder="เลือกพนักงาน"
                            track-by="id">
                        </multiselect>
                    </div>
                </div>
                &nbsp&nbsp
                <button type="button"
                        class="btn btn-success"
                        @click="showAcceptList()">
                    <icon name="print" style="width: 25px"></icon>
                    ตกลง
                </button>
                <button type="button"
                        class="btn btn-secondary ml-5"
                        @click="hideAccept_SalaryModal()">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
        </b-modal>

        <b-modal hide-footer hide-header ref="close_modal">
            <div style="text-align: center;">
                <h4>ปิดงวดภาษีจ่าย</h4>
                <br/>
                <div class="row form-group">
                    <label class="col-4 text-right">เดือนที่ปิด</label>
                    <div class="col-6">
                        <date-picker v-model="close_date"
                                     :lang="lang"
                                     type="month"
                                     placeholder="วันที่ต้องการพิมพ์"
                                     class="w-100"
                                     :format="changeFormatMonth"
                                     confirm>
                        </date-picker>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">วีค</div>
                    <div class="col-6">
                        <b-form-select :options="optionWeek" v-model="close_week"></b-form-select>
                    </div>
                </div>

                <button type="button"
                        class="btn btn-primary"
                        @click="closePayment"
                >ยืนยัน
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex"
import VuePagination from "../../../Pagination";
import Multiselect from "vue-multiselect";
import PreviewSalaryModal from "./Modal/PreviewSalaryModal";
import PreviewSalaryMonthModal from "./Modal/PreviewSalaryMonthModal";
import {domain} from "../../../../util/Constants";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import Loading from "../../../Utility/Loading";
import AddOtEmployeeModal from "../../../../views/HR/Modal/AddOTEmployeeModal";
import RateSocialSecurityModal from "./Modal/RateSocialSecurityModal";
import ReportSalaryModal from "./Modal/ReportSalaryModal";
import FilterSalaryModal from "./Modal/FilterSalaryModal";

export default {
    name: "calculate-salary",
    components: {
        ReportSalaryModal,
        FilterSalaryModal,
        RateSocialSecurityModal,
        AddOtEmployeeModal,
        Loading,
        PreviewSalaryMonthModal,
        PreviewSalaryModal,
        VuePagination,
        Multiselect,
        DatePicker,
    },
    created() {
        // this.$store.dispatch("Employee/setEmployeeFilter", {status : 2});
        this.$store.dispatch("TransactionType/setTransactionTypes");
        // this.$store.dispatch("Employee/clearSalarySearch");
        this.$store.dispatch("Common/setPosition");
        this.getEmployeeAll();
        this.getDepartmentAll();
        this.firstLoadSearch();
    },
    data() {
        return {
            optionDepartment: [],
            optionEmployee: [],
            msg: "",
            optionAccept: {
                week: '',
                month: '',
                file: 'PDF',
                group: '1',
                type: 1,
                employee: [],
                department: [],
            },
            close_date: '',
            close_week: '',
            status_loading: 1,
            status: 2,
            delete_id: "",
            event_submit: false,
            optionPaidPeriod: [
                {id: 1, name: 'วันที่ 1-15'},
                {id: 2, name: 'วันที่ 16-30'},
            ],
            generate: {
                week: '',
                date: '',
                department: '',
                employee: '',
            },
            paid_period: 2,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            changeFormatMonth: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment);
                    return date ? moment(date).format('MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            optionWeek: [
                {text: 'เลือกวีค', value: ''},
                {text: 'วีค 1', value: '1'},
                {text: 'วีค 2', value: '2'}
            ],
            optionMonth: [
                {text: 'เลือกเดือน', value: ''},
                {text: 'มกราคม', value: '1'},
                {text: 'กุมภาพันธ์', value: '2'},
                {text: 'มีนาคม', value: '3'},
                {text: 'เมษายน', value: '4'},
                {text: 'พฤษภาคม', value: '5'},
                {text: 'มิถุนายน', value: '6'},
                {text: 'กรกฎาคม', value: '7'},
                {text: 'สิงหาคม', value: '8'},
                {text: 'กันยายน', value: '9'},
                {text: 'ตุลาคม', value: '10'},
                {text: 'พฤศจิกายน', value: '11'},
                {text: 'ธันวาคม', value: '12'}
            ],
            optionTypeAccept: [
                {text: 'PDF', value: 'PDF'},
                {text: 'Excel', value: 'EXCEL'}
            ],
            optionGroup: [
                {text: 'รวมทั้งหมด(กสิการ,ทหารไทย,เงินสด)', value: '1'},
                {text: 'รวมธนาคาร(กสิกร,ทหารไทย)', value: '2'},
                {text: 'เงินสด', value: '3'},
                {text: 'ทหารไทย', value: '4'},
                {text: 'กสิกร', value: '5'},
            ],
            payroll: {
                trans_date: '',
                week: '',
                month: '',
                effective_date: '',
                type: 1,
                employee: [],
                department: [],
                company_code_t: '0000',
                branch_code_t: '000',
                bank: 1
            },
            bankOption: [
                {value: 1, text: 'kBank'},
                {value: 2, text: 'TMB'}
            ],
            optionActive: [
                {text: "เลือกสถานะ", value: ""},
                {text: 'พนักงาน', value: 1},
                {text: 'ลาออก', value: 2},
            ],
            zero: []
        }
    },
    computed: {
        ...mapState({
            employeeList: state => {
                return state.Employee.employeeList;
            },
            dataPaginate: state => {
                return state.Employee.dataPaginate;
            },
            optionTransaction: state => {
                return state.TransactionType.transactionTypes
                    .filter(data => data.id != 1);
            },
            search: state => {
                return state.Employee.searchSalary
            },
            user: state => {
                return state.Auth.user
            },
        }),
    },
    methods: {
        closePayment() {
            if (this.close_date && this.close_week)
                this.$store.dispatch('PaymentSalary/closePayment', {
                    date: moment(this.close_date).format("YYYY-MM"),
                    week: this.close_week
                }).then(() => this.hideCloseTaxModal());
            else
                alert('กรุณากรอกเดือนและวีคที่ต้องการ')
        },
        clearValue(value) {
            if (value != 2) {
                this.payroll.department = '';
            } else if (value != 3) {
                this.payroll.employee = [];
            }
        },
        generatePayroll() {
            //validate data
            if (this.payroll.bank == 1 && (!this.payroll.trans_date || !this.payroll.effective_date)) {
                alert('กรุณาเลือกวันที่')
            } else if (this.payroll.bank == 2 && (this.payroll.company_code_t.length != 4 || this.payroll.branch_code_t.length != 3)) {
                alert('กรุณาใส่เลขบริษัทให้ครบ 4 หลัก และ เลขสาขาให้ครบ 3 หลัก')
            } else if (this.payroll.type == 2 && this.payroll.department.length == 0) {
                alert('กรุณาเลือกแผนก')
            } else if (this.payroll.type == 3 && this.payroll.employee.length == 0) {
                alert('กรุณาเลือกพนักงาน')
            } else {
                let data = {
                    trans_date: this.payroll.trans_date ? moment(this.payroll.trans_date).format('DD-MM-YYYY') : '',
                    effective_date: this.payroll.effective_date ? moment(this.payroll.effective_date).format('DD-MM-YYYY') : '',
                    type: this.payroll.type,
                    employee: '',
                    department: '',
                    company_code_t: this.payroll.company_code_t,
                    branch_code_t: this.payroll.branch_code_t,
                    bank: this.payroll.bank,
                    week: this.payroll.week,
                    month: moment(this.payroll.month).format('MM'),
                    year: moment(this.payroll.month).format('YYYY'),
                }
                if (this.payroll.type == 2) {
                    this.payroll.department.forEach((value, index) => {
                        data.department += index + 1 == this.payroll.department.length ? value.id : value.id + ',';
                    })
                }
                if (this.payroll.type == 3) {
                    this.payroll.employee.forEach((value, index) => {
                        data.employee += index + 1 == this.payroll.employee.length ? value.id : value.id + ',';
                    })
                }
                window.open(`${domain}/getPayroll?employee=${data.employee}
                    &department=${data.department}
                    &trans_date=${data.trans_date}
                    &effective_date=${data.effective_date}
                    &type=${data.type}
                    &company_code_t=${data.company_code_t}
                    &branch_code_t=${data.branch_code_t}
                    &bank=${data.bank}
                    &week=${data.week}
                    &month=${data.month}
                    &year=${data.year}
                    `);
            }
        },
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showReportSalaryModal() {
            this.$refs.print_report_salary.show();
        },
        hideReportSalaryModal() {
            this.$refs.print_report_salary.hide();
        },
        showPayrollModal() {
            this.$refs.payroll_modal.show();
        },
        showCloseModal() {
            this.$refs.close_modal.show();
        },
        hideCloseModal() {
            this.$refs.close_modal.show();
        },
        hidePayrollModal() {
            this.$refs.payroll_modal.hide();
        },
        showFilterSalaryModal() {
            this.$refs.filter_report_salary.show();
        },
        hideFilterSalaryModal() {
            this.$refs.filter_report_salary.hide();
        },
        showAccept_SalaryModal() {
            this.$refs.accept_salary.show();
        },
        hideAccept_SalaryModal() {
            this.$refs.accept_salary.hide();
        },
        showPreviewSalaryModal() {
            this.$refs.preview_salary.show();
        },
        hidePreviewSalaryModal() {
            this.$refs.preview_salary.hide();
        },
        showPreviewSalaryMonthModal() {
            this.$refs.preview_salary_month.show();
        },
        hidePreviewSalaryMonthModal() {
            this.$refs.preview_salary_month.hide();
        },
        showGenerateSlipMonthModal() {
            this.$refs.generate_slip_month.show();
        },
        hideGenerateSlipMonthModal() {
            this.$refs.generate_slip_month.hide();
        },
        showGenerateModal() {
            this.$refs.generate_slip.show();
        },
        hideGenerateModal() {
            this.$refs.generate_slip.hide();
        },
        showAcceptList() {
            if (this.optionAccept.week != '' && this.optionAccept.month != '') {
                let department = '';
                if (this.optionAccept.type == 2) {
                    this.optionAccept.department.forEach((data, i) => {
                        department += this.optionAccept.department.length == i + 1 ? data.id : data.id + ',';
                    })
                }
                let employee = '';
                if (this.optionAccept.type == 3) {
                    this.optionAccept.employee.forEach((data, i) => {
                        employee += this.optionAccept.employee.length == i + 1 ? data.id : data.id + ',';
                    })
                }
                window.open(`${domain}/EmployeeSalaryAccepted?month=${moment(this.optionAccept.month).format('MM')}&year=${moment(this.optionAccept.month).format('YYYY')}&week=${this.optionAccept.week}&file=${this.optionAccept.file}&group=${this.optionAccept.group}&type=${this.optionAccept.type}
                    &employee=${employee}&department=${department}`);
                this.hideAccept_SalaryModal();
            } else {
                alert('กรุณาเลือกวีค และเดือน')
            }
        },
        hideSocialSecurityModal() {
            this.$refs.social_security.hide();
        },
        showSocialSecurityModal() {
            this.showLoadingModal();
            this.msg = "กรุณารอสักครู่";
            this.status_loading = 1;
            this.$store.dispatch("SocialSecurity/setSocialSecurity").then(() => {
                this.$refs.social_security.show();
                this.hideLoadingModal();
            })
        },
        generateNewSlip() {
            if (!this.generate.week) {
                alert('เลือกวิคที่ต้องการสร้างสลิปเงินเดือน');
            } else if (!this.generate.date) {
                alert('กรุณาเลือกเดือนที่ต้องการสร้างสลิปเงินเดือน')
            } else if (!this.generate.department && !this.generate.employee) {
                alert('กรุณาเลือกพนักงานหรือแผนก')
            } else {
                let employee_id = '';

                if (this.generate.employee.length > 0) {
                    this.generate.employee.forEach((a, i) => {
                        this.generate.employee.length == i + 1 ? employee_id = employee_id + a.id : employee_id = employee_id + a.id + ',';
                    })
                }

                // let employee_id = this.generate.employee ? this.generate.employee.id : '';
                let department_id = this.generate.department ? this.generate.department.id : '';
                let data = {
                    week: this.generate.week,
                    user_id: this.user.id,
                    date: this.generate.date ? moment(this.generate.date).format('YYYY-MM-DD') : '',
                    department_id: department_id,
                    employee_id: employee_id,
                    index: 0
                };
                this.status_loading = 1;
                this.msg = "กำลังออกเงินเดือน 1 จาก กำลังคำนวน คน";
                this.showLoadingModal();
                this.recurGenerateSlip(data);
            }
        },
        recurGenerateSlip(dataNew) {
            let data = {
                week: this.generate.week,
                user_id: this.user.id,
                date: this.generate.date ? moment(this.generate.date).format('YYYY-MM-DD') : '',
                department_id: dataNew.department_id,
                employee_id: dataNew.employee_id,
                index: dataNew.index
            };
            this.$store.dispatch("PaymentSalary/generatePaymentSalary", data).then(res => {
                if (res.zero.length > 0)
                    res.zero.forEach(x => this.zero.push(x))
                let skip_zero = '';
                this.zero.forEach(x => skip_zero += x + ',\n');
                if (res.status == 'next') {
                    data.index++;
                    this.status_loading = 1;
                    this.msg = "กำลังออกเงินเดือน " + (data.index + 1) + " จาก " + res.count + " คน\nโดนข้าม " + skip_zero;
                    this.recurGenerateSlip(data);
                } else {
                    this.$store.dispatch("Employee/setEmployeeFilter", {status: this.status}).then(() => {
                        this.hideLoadingModal();
                        this.showLoadingModal();
                        this.msg = "ออกเงินเดือนพนักงานสำเร็จ";
                        if (skip_zero)
                            this.msg += "\nโดนข้าม " + skip_zero;
                        this.status_loading = 2;
                    })
                }
            }).catch(() => {
                this.showLoadingModal();
                this.msg = "ออกรายงานไม่สำเร็จ";
                this.status_loading = 3;
            });
            this.hideGenerateModal();
        },
        generateNewSlipMonth() {
            this.$store.dispatch("PaymentSalary/generatePaymentSalaryMonth", this.user.id).then(() => {
                alert('สร้าง slip สำเร็จ');
                this.$store.dispatch("Employee/setEmployeeFilter", {status: this.status})
            });
            this.hideGenerateSlipMonthModal();

        },
        getEmployeeByPaidPeriod(status) {
            this.status = status;
            if (this.event_submit) {
                if (this.search.transaction_type) {
                    this.search.transaction_type_id = this.search.transaction_type.id
                } else {
                    this.search.transaction_type_id = null
                }
                if (this.search.department) {
                    this.search.department_id = this.search.department.id
                } else {
                    this.search.department_id = null
                }
                let data = {
                    department_id: this.search.department_id,
                    transaction_type_id: this.search.transaction_type_id,
                    status: status,
                    employee_id: this.search.employee ? this.search.employee.id : '',
                };
                this.$store.dispatch('Employee/searchPaymentSalary', data)
            } else {
                this.$store.dispatch("Employee/setEmployeeFilter", {status: status})
            }
        },
        saveRateSocialSecurity(value) {
            //console.log(value);
            if (value) {
                this.showLoadingModal();
                this.msg = "กรุณารอสักครู่";
                this.status_loading = 1;
                this.$store.dispatch("SocialSecurity/saveSocialSecurity", {
                    id: value.id,
                    data: value,
                }).then(() => {
                    this.showLoadingModal();
                    this.msg = "บันทึกประกันสำเร็จ";
                    this.status_loading = 2;
                }).catch(() => {
                    this.showLoadingModal();
                    this.msg = "บันทึกไม่สำเร็จ";
                    this.status_loading = 3;
                })
            } else {
                this.hideSocialSecurityModal();
            }
        },
        getDepartmentAll() {
            this.$store.dispatch("Department/getAllDepartment").then(res => {
                this.optionDepartment = res;
            })
        },
        getEmployeePage() {
            const page = this.dataPaginate.current_page;
            if (this.event_submit) {
                this.event_submit = true;
                let employee_id = '';
                let department_id = '';
                if (this.search.employee.length > 0) {
                    this.search.employee.forEach((a, i) => {
                        this.search.employee.length == i + 1 ? employee_id = employee_id + a.id : employee_id = employee_id + a.id + ',';
                    })
                }
                if (this.search.department.length > 0) {
                    this.search.department.forEach((a, i) => {
                        this.search.department.length == i + 1 ? department_id = department_id + a.id : department_id = department_id + a.id + ',';
                    })
                }
                if (this.search.transaction_type) {
                    this.search.transaction_type_id = this.search.transaction_type.id
                } else {
                    this.search.transaction_type_id = null
                }
                let data = {
                    department_id: department_id,
                    transaction_type_id: this.search.transaction_type_id,
                    status: this.status,
                    employee_id: employee_id,
                    active: this.search.active,
                    page: page
                };
                this.showLoadingModal();
                this.msg = 'กรุณารอสักครู่';
                this.status_loading = 1;
                this.$store.dispatch("Employee/searchPaymentSalary", data).then(() => {
                    this.hideLoadingModal();
                });
            } else {
                this.$store.dispatch("Employee/setEmployeeFilter", {page, status: this.status});
            }
        },
        searchSalaryPayment() {
            this.event_submit = true;
            let employee_id = '';
            let department_id = '';
            if (this.search.employee.length > 0) {
                this.search.employee.forEach((a, i) => {
                    this.search.employee.length == i + 1 ? employee_id = employee_id + a.id : employee_id = employee_id + a.id + ',';
                })
            }
            if (this.search.department.length > 0) {
                this.search.department.forEach((a, i) => {
                    this.search.department.length == i + 1 ? department_id = department_id + a.id : department_id = department_id + a.id + ',';
                })
            }
            if (this.search.transaction_type) {
                this.search.transaction_type_id = this.search.transaction_type.id
            } else {
                this.search.transaction_type_id = null
            }
            let data = {
                department_id: department_id,
                transaction_type_id: this.search.transaction_type_id,
                status: this.status,
                employee_id: employee_id,
                active: this.search.active,
                page: 1
            };
            this.showLoadingModal();
            this.msg = 'กรุณารอสักครู่';
            this.status_loading = 1;
            this.$store.dispatch("Employee/searchPaymentSalary", data).then(() => {
                this.hideLoadingModal();
            });
        },
        clearSearch() {
            this.$store.dispatch("Employee/clearSalarySearch").then(() => {
                this.searchSalaryPayment();
            })
        },
        firstLoadSearch() {
            this.event_submit = true;
            let employee_id = '';
            let department_id = '';
            if (this.search.employee.length > 0) {
                this.search.employee.forEach((a, i) => {
                    this.search.employee.length == i + 1 ? employee_id = employee_id + a.id : employee_id = employee_id + a.id + ',';
                })
            }
            if (this.search.department.length > 0) {
                this.search.department.forEach((a, i) => {
                    this.search.department.length == i + 1 ? department_id = department_id + a.id : department_id = department_id + a.id + ',';
                })
            }
            if (this.search.transaction_type) {
                this.search.transaction_type_id = this.search.transaction_type.id
            } else {
                this.search.transaction_type_id = null
            }
            let data = {
                department_id: department_id,
                transaction_type_id: this.search.transaction_type_id,
                status: this.status,
                employee_id: employee_id,
                active: this.search.active
            };
            this.$store.dispatch("Employee/searchPaymentSalary", data)
        },
        goToPaymentSalary(employee_id) {
            this.showLoadingModal();
            this.msg = 'กรุณารอสักครู่';
            this.status_loading = 1;
            this.$store.dispatch("Employee/getEmployeeByID", employee_id).then(() => {
                this.$store.dispatch("PaymentSalary/setPaymentSalary", {
                    employee_id: employee_id,
                    page: 1,
                })
                this.hideLoadingModal();
                this.$router.push({
                    name: "payment-salary-history"
                })
            })
        },
        previewSalary(submitData) {
            if (submitData) {
                let data = {
                    week: submitData.week,
                    date: submitData.date,
                    name: this.user.name,
                    employee_id: submitData.employee_id,
                    department_id: submitData.department_id,
                }
                this.showLoadingModal();
                this.msg = "กำลังดาวน์โหลดข้อมูล";
                this.status_loading = 1;
                this.$store.dispatch("Employee/previewSalaryPDF", data).then(url => {
                    window.open(url)
                    this.hideLoadingModal();
                }).catch(err => {
                    //console.log(err);
                    this.hideLoadingModal();
                    this.msg = "ดาวน์โหลดข้อมูลไม่สำเร็จ";
                    this.status_loading = 3;
                })
            }
            this.hidePreviewSalaryModal();
        },
        previewSalaryMonth(submitData) {
            if (submitData != 0) {
                window.open(domain + "/preview-salary-month-pdf?name=" + this.user.name);
            }
            this.hidePreviewSalaryMonthModal();
        },
        getEmployeeAll() {
            this.$store.dispatch("Employee/getEmployeeAll").then(res => {
                this.optionEmployee = res;
            })
        },
        printReportSalaryPDF(value) {
            if (value) {
                // let localIP = 'http://192.168.1.221:80/somboon/api'
                window.open(`${domain}/print_payment_salary_report_new?start_date=${value.start_date}&end_date=${value.end_date}&employee_id=${value.employee_id}&department_id=${value.department_id}&type=${value.type}&only_view=${value.only_view}`);
                // window.open(`${domain}/print_payment_salary_report?start_date=${value.start_date}&end_date=${value.end_date}&employee_id=${value.employee_id}&department_id=${value.department_id}`);
                this.hideReportSalaryModal();
            }
            this.hideReportSalaryModal();
        },
        FilterSalaryModal(value) {
            if (value) {
                this.showLoadingModal();
                this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
                this.status_loading = 1;
                this.$store.dispatch("Employee/exportSlipSalaryEmployee", value).then(url => {
                    window.open(url, '_blank')
                    this.hideLoadingModal();
                }).catch(err => {
                    //console.log(err);
                    this.showLoadingModal();
                    this.msg = "ดาวโหลดเอกสารไม่สำเร็จ";
                    this.status_loading = 3;
                })
            }
            this.hideFilterSalaryModal();
        }
    },
}
</script>

<style scoped>
.btn-green {
    background-color: #00a699;
    color: white;
}

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
    background-color: #FCD61B;
    color: black;
    font-weight: bold;
}

.navbar-nav .nav-link {
    color: black;
}

</style>
